const classPrefix = 'main-banner'
const dataPrefix = 'data-main-banner'
const $container = document.querySelector(`[${dataPrefix}]`)


export function mainBanner() {


}
